import { render, staticRenderFns } from "./OAutoBackup.vue?vue&type=template&id=7af65d14&scoped=true&"
import script from "./OAutoBackup.vue?vue&type=script&lang=js&"
export * from "./OAutoBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af65d14",
  null
  
)

export default component.exports